const translations = {
	appreciation_client:
		"Comment êtes-vous entré en relation, quelle est son activité, pourquoi réside-t-il à l'étranger le cas échéant ? Personne morale, tous les associés sont-ils identifiés ?",
	appreciation_operation: "Perspective de l'opération, vous paraît-elle normale et cohérente et pourquoi ? Si les fonds proviennent d'un tiers, quel en est le motif ?",
	non_professional_classification_acknowledgment:
		"Vous pouvez formuler une demande écrite WENIMMO afin d'être classé en « client professionnel » et renoncer à une partie de la protection. Dans ce cas, nous vous remercions de contacter WENIMMO à backoffice@wenimmo.com",
};

export default translations;
